// AnnouncementsAck.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
  Typography,
  Button,
  Chip,
} from "@mui/material";

export default function AnnouncementsAck({ open, onClose, data, loading = false }) {
  // Safely extract array
  const records = Array.isArray(data) ? data : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Announcement Acknowledgments</DialogTitle>

      <DialogContent>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : records.length === 0 ? (
          <Typography variant="body2" sx={{ py: 2 }}>
            No acknowledgment records available.
          </Typography>
        ) : (
          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ mt: 1, borderRadius: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Tutor</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Tutor ID</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Announcement ID</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Organization ID</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Acknowledged</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Acknowledged At</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {records.map((row, index) => (
                  <TableRow
                    key={row.id || index}
                    sx={{
                      "&:nth-of-type(odd)": { backgroundColor: "action.hover" },
                    }}
                  >
                    <TableCell>{row.id ?? "—"}</TableCell>
                    <TableCell>
                      {row.first_name?.trim() || row.last_name?.trim()
                        ? `${row.first_name ?? ""} ${row.last_name ?? ""}`.trim()
                        : "—"}
                    </TableCell>
                    <TableCell>{row.tutor_id ?? "—"}</TableCell>
                    <TableCell>{row.announcement_id ?? "—"}</TableCell>
                    <TableCell>{row.organization_id ?? "—"}</TableCell>
                    <TableCell>
                      {row.acknowledged ? (
                        <Chip
                          label="Acknowledged"
                          color="success"
                          size="small"
                          sx={{ fontWeight: 600 }}
                        />
                      ) : (
                        <Chip
                          label="Pending"
                          color="warning"
                          size="small"
                          sx={{ fontWeight: 600 }}
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      {row.acknowledged_at
                        ? new Date(row.acknowledged_at).toLocaleString()
                        : "—"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions sx={{ pr: 3, pb: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}